import React from 'react';
import { Button } from './Button';
import { spacing } from '../theme/spacing';

interface WizardFooterNavProps {
    onBack: () => void;
    onNext: () => void;
    isBackDisabled?: boolean;
    isNextDisabled?: boolean;
    nextLabel?: string;
    isLastStep?: boolean;
    isLoading?: boolean;
    loadingLabel?: string;
}

export const WizardFooterNav: React.FC<WizardFooterNavProps> = ({
    onBack,
    onNext,
    isBackDisabled = false,
    isNextDisabled = false,
    nextLabel = 'Seuraava',
    isLastStep = false,
    isLoading = false,
    loadingLabel = 'Lähetetään…',
}) => {
    const containerStyle: React.CSSProperties = {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: spacing[32],
        gap: spacing[16],
    };

    return (
        <div style={containerStyle}>
            <Button
                variant="secondary"
                onClick={onBack}
                disabled={isBackDisabled}
            >
                Takaisin
            </Button>

            <Button
                variant="primary"
                onClick={onNext}
                disabled={isNextDisabled}
                isLoading={isLoading}
            >
                {isLoading
                    ? loadingLabel
                    : (isLastStep ? 'Lähetä varauspyyntö' : (nextLabel || 'Jatka'))
                }
            </Button>
        </div>
    );
};
